import "core-js/modules/esnext.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import $ from 'jquery';
import QRCode from 'qrcodejs2';
import { setImgsize } from '@/utils/utils';

//3d文物参数 √
var tex, scale, PLight, Alight, hightlight, photonear, photofar, ambientcolor, pointColor, normalPath, parallelLight, normalMapStrength, manager;
var angleX = [];
var angleY = [];
var angleZ = [];
var axisX = [];
var anisY = [];
var anisZ = [];
var tex = [];
var model = [];
var modelName = [];
var mtl = [];
var index2 = [];
var index = [];
var mtlUrl = [];
var mtlName = [];
var normalPath = [];
var stageUrl = process.env.VUE_APP_IMG_URL;
var camera,
  scene,
  renderer,
  controls,
  ob,
  fbx = 0,
  onProgress,
  attributeModels;
export default {
  data() {
    return {
      singleform: {},
      options: {
        source: '',
        width: 480,
        height: 327,
        frames: 34,
        framesX: 6,
        sense: -1
      },
      activeIndex: 0,
      showDetail: true,
      code: '',
      detail: {},
      loadingIframe: true,
      endY: 0,
      moveY: 0,
      endMoveY: 0,
      boxTop: 0,
      startY: 0,
      beforeY: 0,
      screenHeight: 0,
      iframeShow: false,
      isPause: false,
      clickNumForm: {},
      //访问量表单
      isBlue: false
    };
  },
  props: ['modelData', 'config', 'detailUrl', 'windowTop'],
  methods: {
    // 点赞量+1
    addLike(record) {
      let putParams;
      putParams = [{
        "compt": "numberinput",
        "values": [{
          "val": parseInt(this.detail.likeNum) + 1
        }],
        "alias": 'pblLikeNum'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": record.chuanLiu
        }],
        "alias": 'chuanLiu'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": record.yuDi
        }],
        "alias": 'yuDi'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": parseInt(record.pbl)
        }],
        "alias": 'pbl'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": record.pc
        }],
        "alias": 'pc'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": parseInt(record.all)
        }],
        "alias": 'all'
      }];
      putParams = encodeURI(JSON.stringify(putParams));
      this.detail.likeNum++;
      this.$api.editForm(this.$route.query.fid, this.clickNumForm.formUserId, putParams, this.clickNumForm.formId).then(res => {});
    },
    hideModel() {
      if (this.detail.type == '3D') {
        this.clearScene();
      }
      this.$parent.hideWindow();
    },
    changeActive(index, type) {
      if (type == 'blue' && this.$route.query.fid != 203966) return;
      this.activeIndex = index;
      this.showDetail = !index ? true : false;
    },
    // 点击音频
    handelAudio() {
      this.$refs.audioItem.paused ? this.$refs.audioItem.play() : this.$refs.audioItem.pause();
      this.$refs.audioItem.paused ? this.isPause = false : this.isPause = true;
    },
    // 文物清空
    clearScene() {
      angleX = [];
      angleY = [];
      angleZ = [];
      axisX = [];
      anisY = [];
      anisZ = [];
      tex = [];
      model = [];
      modelName = [];
      mtl = [];
      index2 = [];
      index = [];
      mtlUrl = [];
      mtlName = [];
      normalPath = [];
      if (scene) {
        scene.traverse(child => {
          if (child.material) {
            child.material.dispose();
          }
          if (child.geometry) {
            child.geometry.dispose();
          }
          child = null;
        });
      }
      if (renderer) {
        renderer.forceContextLoss();
        renderer.dispose();
        renderer.domElement = null;
      }
      controls = null;
      scene = null;
      camera = null;
      renderer = null;
      document.getElementById('containRelics').innerHTML = '';
    },
    getDetailByCode() {
      let a = {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.code
        }]],
        model: 0
      };
      this.singleform.deptId = this.$route.query.fid || '151066';
      this.singleform.formId = this.config.formId_a || '112720';
      this.singleform.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(this.singleform).then(res => {
        this.setData(res.dataList[0].formIdValueData, 'name');
      });
    },
    getFileData() {
      let singleformFile = {
        deptId: this.singleform.deptId,
        formId: this.config.formId_3d || '113010'
      };
      let b = this.modelData.autoCode ? {
        filters: [[{
          alias: "autoCode",
          compt: "editinput",
          express: "===",
          range: null,
          val: this.modelData.autoCode
        }]],
        model: 0
      } : {
        filters: [[{
          alias: "autoId",
          compt: "editinput",
          express: "===",
          id: 28,
          range: null,
          val: this.code
        }]],
        model: 0
      };
      let index = this.modelData.m_index && !this.modelData.autoCode ? parseInt(this.modelData.m_index) : 0;
      singleformFile.searchStr = encodeURI(JSON.stringify(b));
      this.$api.singleadvanceSearch(singleformFile).then(res => {
        this.singleform.formId_real = res.dataList[0].formId;
        this.singleform.formUserId = res.dataList[index].id;
        this.setData(res.dataList[index].formIdValueData);
        this.setRecord(res.dataList[index]);
      });
    },
    // 增加访问量 type 
    setRecord(item, type) {
      if (!this.modelData.autoCode) return;
      let params = {
        formId: 571415,
        deptId: this.$route.query.fid || '151066'
      };
      let b = {
        filters: [[{
          alias: "autoCode",
          compt: "editinput",
          express: "===",
          range: null,
          val: this.modelData.autoCode
        }]],
        model: 0
      };
      params.searchStr = encodeURI(JSON.stringify(b));
      // 获取访问量
      this.$api.singleadvanceSearch(params).then(res => {
        if (!res.dataList.length) return this.resetRecord(); //没有的时候新增一条数据
        this.clickNumForm.formUserId = res.dataList[0].id;
        this.clickNumForm.formId = res.dataList[0].formId;
        let data = res.dataList[0].formIdValueData;
        this.detail.likeNum = this.getValInFormData(data, 'pblLikeNum') || 0;
        let record = {
          chuanLiu: this.getValInFormData(data, 'chuanliu') || 0,
          pbl: this.getValInFormData(data, 'pbl') || 0,
          pc: this.getValInFormData(data, 'pc') || 0,
          yuDi: this.getValInFormData(data, 'yuDi') || 0,
          all: this.getValInFormData(data, 'all') || 0
        };
        if (type == 'addLike') return this.addLike(record); //新增点赞量
        // 访问量+1
        let putParams;
        putParams = [{
          "compt": "numberinput",
          "values": [{
            "val": record.chuanLiu
          }],
          "alias": 'chuanLiu'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": record.yuDi
          }],
          "alias": 'yuDi'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": parseInt(record.pbl) + 1
          }],
          "alias": 'pbl'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": record.pc
          }],
          "alias": 'pc'
        }, {
          "compt": "numberinput",
          "values": [{
            "val": parseInt(record.all) + 1
          }],
          "alias": 'all'
        }];
        putParams = encodeURI(JSON.stringify(putParams));
        this.$api.editForm(this.$route.query.fid, res.dataList[0].id, putParams, res.dataList[0].formId).then(res => {});
      });
    },
    // 新增访问量数据
    resetRecord() {
      let putParams = [{
        "compt": "numberinput",
        "values": [{
          "val": 0
        }],
        "alias": 'chuanLiu'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 0
        }],
        "alias": 'yuDi'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 1
        }],
        "alias": 'pbl'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 0
        }],
        "alias": 'pc'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": 1
        }],
        "alias": 'all'
      }, {
        "compt": "editinput",
        "values": [{
          "val": this.$route.query.autoCode || this.detail.autoCode
        }],
        "alias": 'autoCode'
      }, {
        "compt": "editinput",
        "values": [{
          "val": this.detail.name
        }],
        "alias": 'name'
      }, {
        "compt": "editinput",
        "values": [{
          "val": this.detail.type
        }],
        "alias": 'type'
      }];
      console.log(putParams);
      putParams = encodeURI(JSON.stringify(putParams));
      let formparams = {
        deptId: this.$route.query.fid,
        formId: 571415,
        uid: 170870413
      };
      this.$api.addFormdata(formparams, putParams).then(res => {});
    },
    // 数据获取
    setData(data, type, hideOther) {
      if (type == 'name') {
        this.detail.name = this.getValInFormData(data, 'antiqueName');
        this.detail.img = this.getValInFormData(data, 'thumbPath', 'img');
        this.detail.description = this.getValInFormData(data, 'description');
        this.detail.audio = this.getValInFormData(data, 'audio', 'objectId');
        this.detail.zhuanti = this.getValInFormData(data, 'mobileSpecial');
        return this.getFileData();
      } else {
        this.detail.type = this.getValInFormData(data, 'type');
        if (this.detail.audio) {
          this.getAudioPath(this.detail.audio);
        }
        if (this.detail.zhuanti) {
          new QRCode(this.$refs.zhuantiCode, {
            text: this.detail.zhuanti,
            //页面地址 ,如果页面需要参数传递请注意哈希模式#
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        }
        if (this.detail.type == '图片') {
          this.detail.images = data['image'].groupValues[0].values[0].map(img => {
            // return process.env.NODE_ENV == 'development' ? stageUrl + img.name : (img.fileUrl ? img.fileUrl.replace('http:', 'https:') : '')
            // return process.env.NODE_ENV == 'development' ? stageUrl + img.name : (img.fileUrl ? setImgsize(img, 320, 420) : '')
            // return img.fileUrl ? setImgsize(img, 860, 1128) : ''
            return img.fileUrl ? img.fileUrl.replace('http:', 'https:') : '';
          });
          return this.initImage();
        }
        if (this.detail.type == '视频') {
          let objectId = this.getValInFormData(data, 'video', 'objectId');
          this.$nextTick(() => {
            this.getAudioPath(objectId, 'video');
          });
          return;
        }
        this.detail.type == '3D' ? '' : this.init360(data);
      }
    },
    getAudioPath(path, type) {
      this.$api.getUrlByObjectId(path).then(res => {
        let data = res.download.replace('http://d0.ananas.chaoxing.com/', 'https://museum.chaoxing.com/');
        !type ? this.detail.audio = data : this.detail.video = data;
        console.log(this.detail.audio);
      });
    },
    getValInFormData(data, id, type) {
      if (!data[id] || !data[id].groupValues[0] || !data[id].groupValues[0].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[0].values[0][0]) return;
        target = process.env.NODE_ENV == 'development' ? stageUrl + data[id].groupValues[0].values[0][0].name : data[id].groupValues[0].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : target;
      } else {
        target = type ? data[id].groupValues[0].values[0][0][type] : data[id].groupValues[0].values[0][0].val;
      }
      return target;
    },
    // 图片文物类型加载
    initImage(data) {
      this.$nextTick(() => {
        this.swiperElImg = new Swiper(this.$refs.swiperImg, {
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          slidesPerView: 1,
          initialSlide: 0,
          preventClicksPropagation: true,
          // 阻止click冒泡。拖动Swiper时阻止click事件
          centeredSlides: true,
          runCallbacksOnInit: false,
          touchMoveStopPropagation: true,
          slideToClickedSlide: true,
          observer: true,
          observeSlideChildren: true
        });
      });
    },
    // 360文物加载
    init360(data) {
      let images = data['panorama'].groupValues[0].values[0];
      images = images.map(item => {
        return item.fileUrl;
      });
      this.detail.images360 = images;
      this.options.source = images;
      this.$nextTick(() => {
        loadImage();
      });
    },
    animate() {
      requestAnimationFrame(this.animate);
      if (controls) {
        controls.update();
        this.render();
      } else {
        cancelAnimationFrame(this.animate);
      }
    },
    render() {
      renderer.render(scene, camera);
    },
    modeltouchstart(e) {
      // if (e.target.className !== 'model') return
      this.startY = e.targetTouches[0].pageY;
      this.endY = this.$refs.model.offsetTop;
    },
    modeltouchmove(e) {
      console.log('modeltouchmove', e.target);
      // if (e.target.className !== 'model') return
      this.moveY = e.targetTouches[0].pageY - this.startY;
      let moveY = e.targetTouches[0].pageY;
      //让盒子距左边和上面的距离等于 x 它原来的距离 加上 moveX移动的距离
      if (this.endY + this.moveY < this.screenHeight - (this.isBlue ? 1420 : 1920)) {
        this.endMoveY = this.endY + this.moveY;
        this.beforeY = this.endMoveY;
        this.$parent.changeWindowTop(this.endMoveY);
      }
    },
    setCode() {
      let url = `${location.origin}${location.pathname}#/new3DDetail?type=${this.$route.query.fid === '165400' ? 'white' : 'black'}&fid=${this.$route.query.fid}&code=${this.code}${this.modelData.autoCode ? `&autoCode=${this.modelData.autoCode}` : ''}`;
      this.$nextTick(() => {
        this.$refs.erWeiMaCode.innerHTML = '';
        new QRCode(this.$refs.erWeiMaCode, {
          text: url,
          //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    }
  },
  mounted() {
    this.screenHeight = window.screen.height;
    this.code = this.modelData.code;
    this.setCode();
    this.getDetailByCode();
    this.$nextTick(() => {
      setTimeout(() => {
        this.loadingIframe = false;
      }, 1500);
    });
  },
  created() {
    let blueTop = this.$route.query.type == 'blue' || this.$route.query.fid == 203966 ? 250 : 0;
    this.isBlue = !!blueTop;
    console.log(this.isBlue);
    !this.windowTop ? this.boxTop = window.screen.height > 5759 ? 2800 : window.screen.height > 3850 ? 1920 : 900 : this.boxTop = this.windowTop;
    this.boxTop += blueTop;
    if (this.modelData.type != '360') return;
    let list2 = ['threesixty.js'];
    list2.map(item => {
      let oScript = document.createElement('script');
      oScript.type = 'text/javascript';
      oScript.src = `js/360/${item}`;
      document.body.appendChild(oScript);
    });
  },
  computed: {}
};